export enum PageEnum {
  // basic login path
  BASE_LOGIN = '/login',
  // google redirect
  GOOGLE_REDIRECT = '/google',
  //
  RESET_PAGE = '/reset',
  // basic home path
  BASE_HOME = '/recents',
  // error page path
  ERROR_PAGE = '/exception',
  // error log page path
  ERROR_LOG_PAGE = '/error-log/list',
}
